import { createFileRoute } from "@tanstack/react-router"
import { KlaviyoIntegration } from "modules/settings/components/integrations/klaviyo"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { z } from "zod"

const KlaviyoSearchSchema = PaginationSearchSchema.merge(SearchQuerySchema).extend({
  segmentId: z.string().optional(),
  includeIds: z.array(z.string()).optional(),
  field: z.string().optional(),
  order: z.enum(["asc", "desc"]).optional(),
})

export const Route = createFileRoute("/_base/_auth/settings/integrations/klaviyo")({
  component: KlaviyoIntegration,
  validateSearch: KlaviyoSearchSchema,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.klaviyo.title"),
    })
  },
})
